import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CourtsApiService } from 'src/app/core/services/api/courts-api.service';
import { City } from '../../models/courts/city';

@Component({
  selector: 'app-city-create-edit',
  templateUrl: './city-create-edit.component.html',
  styleUrls: ['./city-create-edit.component.scss']
})
export class CityCreateEditComponent implements OnInit {
  public city: City;

  @ViewChild('cityModal') cityModal;
  @Output() submit: EventEmitter<City> = new EventEmitter<City>();

  modalRef: NgbModalRef;

  constructor(private modalService: NgbModal,
    private api: CourtsApiService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService) {
  }

  ngOnInit(): void {
  }

  // handle the popup
  open(city: City) {
    this.city = Object.assign(new City(), city);
    this.modalRef = this.modalService.open(this.cityModal, { centered: true, size: 'lg' });
  }

  close() {
    this.modalRef.close();
  }

  onSubmit() {
    this.spinner.show();
    const url = this.city.id ? this.api.updateCity(this.city) : this.api.createCity(this.city);
    url.subscribe(
      c => {
        this.spinner.hide();
        this.submit.emit(c);
      }
    );
  }
}
